import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { HttpParams, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ClienteCampoPersonalizadoService {

  constructor(private http: HttpClient) {}

  consultarClienteCampoPersonalizadoComPaginacao(descri: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, tipoAplicacao) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('tipoAplicacao', tipoAplicacao);

    if (descri.trim() !== '') {
      parametros = parametros.set('descri', descri);
    }

    return this.http.get<any>(globals.apiUrl + '/api/ClienteCampoPersonalizado/ListaPag',
      {
        params: parametros
      });
  }

  consultarTodosClienteCampoPersonalizado() {
    return this.http.get<any>(globals.apiUrl + '/api/ClienteCampoPersonalizado/Lista');
  }

  consultarPorIdClienteCampoPersonalizado(id) {
    return this.http.get<any>(globals.apiUrl + '/api/ClienteCampoPersonalizado/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(campoPersonalizado) {
    return this.http.post(globals.apiUrl + '/api/ClienteCampoPersonalizado/Salvar', campoPersonalizado);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/ClienteCampoPersonalizado/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  verificaSePodeExcluirItem(id) {
    return this.http.get<any>(globals.apiUrl + '/api/ClienteCampoPersonalizado/PodeExcluirItem',
      { params: new HttpParams().set('idItem', id) });
  }
}
